// extracted by mini-css-extract-plugin
export default {"verticalInfoListContainer":"InfoList_verticalInfoListContainer__Kkb4u"};